// import React, { useEffect, useState } from 'react';
// import './BudgetLines.css';
// import privateApi from '../../apis/privateApi';
// import Spinner from '../../components/Spinner/Spinner';
// import ConfirmDialog from '../../components/ConfirmDialog/ConfirmDialog';

// import { Link, useNavigate } from "react-router-dom";
// import { FiEye, FiEdit, FiTrash2 } from "react-icons/fi";

// const BudgetLines = () => {
//     const navigate = useNavigate();

//     const [budgetLines, setBudgetLines] = useState([]);
//     const [loading, setLoading] = useState(true);
//     const [error, setError] = useState('');

//     const [filters, setFilters] = useState({
//         budgetId: '',
//         administrativeUnitCode: '',
//         programmeCode: '',
//         economicSegmentCode: '',
//         fundCode: '',
//         scope: '',
//         stateCode: '',
//         lgaCode: '',
//         minAmount: '',
//         maxAmount: ''
//     });

//     const [pagination, setPagination] = useState({
//         page: 1,
//         limit: 10,
//         totalPages: 1,
//         totalRecords: 0
//     });

//     // Delete states
//     const [confirmOpen, setConfirmOpen] = useState(false);
//     const [confirmToken, setConfirmToken] = useState("");
//     const [deleteId, setDeleteId] = useState(null);


//     const generateToken = () =>
//         Math.random().toString(36).substring(2, 8).toUpperCase();


//     // Fetch Budget Lines
//     const fetchBudgetLines = async () => {

//         try {

//             setLoading(true);
//             setError('');

//             const query = new URLSearchParams({
//                 ...filters,
//                 page: pagination.page,
//                 limit: pagination.limit
//             });

//             const { data } = await privateApi.get(`/api/budget-lines?${query}`);

//             if (data.success) {

//                 setBudgetLines(data.data);

//                 setPagination(prev => ({
//                     ...prev,
//                     totalPages: data.pagination?.pages || 1,
//                     totalRecords: data.pagination?.total || data?.data?.length
//                 }));

//             } else {

//                 setBudgetLines([]);
//                 setError('No records found');

//             }

//         } catch (err) {

//             setBudgetLines([]);
//             setError(err.response?.data?.message || 'Failed to fetch budget lines.');

//         } finally {

//             setLoading(false);

//         }

//     };


//     useEffect(() => {
//         const initialFetchBudgetLines = async () => {

//             try {

//                 setLoading(true);
//                 setError('');

//                 const query = new URLSearchParams({
//                     ...filters,
//                     page: pagination.page,
//                     limit: pagination.limit
//                 });

//                 const { data } = await privateApi.get(`/api/budget-lines?${query}`);
//                 if (data.success) {

//                     setBudgetLines(data.data);

//                     setPagination(prev => ({
//                         ...prev,
//                         totalPages: data.pagination?.pages || 1,
//                         totalRecords: data.pagination?.total || data?.data?.length
//                     }));

//                 } else {

//                     setBudgetLines([]);
//                     setError('No records found');

//                 }

//             } catch (err) {

//                 setBudgetLines([]);
//                 setError(err.response?.data?.message || 'Failed to fetch budget lines.');

//             } finally {

//                 setLoading(false);

//             }

//         };
//         initialFetchBudgetLines();
//     }, [filters, pagination.page, pagination.limit]);


//     // const handleChange = (e) => {
//     //     const { name, value } = e.target;
//     //     setFilters(prev => ({ ...prev, [name]: value }));
//     // };

//     const handleChange = (e) => {
//         const { name, value } = e.target;

//         setFilters(prev => {
//             let updated = { ...prev, [name]: value };

//             if (name === "stateCode" && value) {
//                 updated.scope = "state";
//             }

//             if (name === "lgaCode" && value) {
//                 updated.scope = "lga";
//             }

//             return updated;
//         });
//     };

//     const applyFilters = () => {
//         setPagination(prev => ({ ...prev, page: 1 }));
//         fetchBudgetLines();
//     };


//     const handleLimitChange = (e) => {
//         const limit = parseInt(e.target.value, 10);
//         setPagination(prev => ({ ...prev, limit, page: 1 }));
//     };


//     const nextPage = () => {
//         if (pagination.page < pagination.totalPages) {
//             setPagination(prev => ({ ...prev, page: prev.page + 1 }));
//         }
//     };


//     const prevPage = () => {
//         if (pagination.page > 1) {
//             setPagination(prev => ({ ...prev, page: prev.page - 1 }));
//         }
//     };


//     // -------------------
//     // Delete logic
//     // -------------------

//     const handleDeleteClick = (id) => {

//         const token = generateToken();

//         setDeleteId(id);
//         setConfirmToken(token);
//         setConfirmOpen(true);

//     };


//     const handleConfirmDelete = async (input) => {

//         if (input !== confirmToken) {

//             alert("Incorrect confirmation code.");

//             setConfirmOpen(false);
//             return;

//         }

//         try {

//             await privateApi.delete(`/api/budget-lines/${deleteId}`);

//             fetchBudgetLines();

//         } catch (err) {

//             alert(err.response?.data?.message || "Delete failed.");

//         } finally {

//             setConfirmOpen(false);
//             setDeleteId(null);

//         }

//     };


//     const handleCancelDelete = () => {
//         setConfirmOpen(false);
//         setDeleteId(null);
//     };


//     return (

//         <div className="budget-lines-container">

//             <header className="budget-lines-header">
//                 <h2>Budget Lines</h2>
//                 <button className="budget-lines-back-btn" onClick={() => navigate(-1)}>
//                     Back
//                 </button>
//             </header>


//             {/* Filters */}
//             <div className="budget-lines-filters">
//                 <select
//                     name="scope"
//                     value={filters.scope}
//                     onChange={handleChange}
//                 >
//                     <option value="">All Scopes</option>
//                     <option value="state">State</option>
//                     <option value="lga">LGA</option>
//                 </select>

//                 <input
//                     name="administrativeUnitCode"
//                     placeholder="Admin Unit Code"
//                     value={filters.administrativeUnitCode}
//                     onChange={handleChange}
//                 />

//                 <input
//                     name="economicSegmentCode"
//                     placeholder="Economic Code"
//                     value={filters.economicSegmentCode}
//                     onChange={handleChange}
//                 />

//                 <input
//                     name="programmeCode"
//                     placeholder="Programme Code"
//                     value={filters.programmeCode}
//                     onChange={handleChange}
//                 />

//                 <input
//                     name="fundCode"
//                     placeholder="Fund Code"
//                     value={filters.fundCode}
//                     onChange={handleChange}
//                 />

//                 <input
//                     name="stateCode"
//                     placeholder="State Code"
//                     value={filters.stateCode}
//                     onChange={handleChange}
//                 />

//                 <input
//                     name="lgaCode"
//                     placeholder="LGA Code"
//                     value={filters.lgaCode}
//                     onChange={handleChange}
//                 />

//                 <input
//                     name="minAmount"
//                     placeholder="Min Amount"
//                     value={filters.minAmount}
//                     onChange={handleChange}
//                 />

//                 <input
//                     name="maxAmount"
//                     placeholder="Max Amount"
//                     value={filters.maxAmount}
//                     onChange={handleChange}
//                 />

//                 <button onClick={applyFilters}>Search</button>

//             </div>


//             {/* Limit Selector */}
//             <div className="budget-lines-limit-selector">

//                 <label>
//                     Show per page:

//                     <select value={pagination.limit} onChange={handleLimitChange}>
//                         <option value={10}>10</option>
//                         <option value={50}>50</option>
//                         <option value={100}>100</option>
//                     </select>

//                 </label>

//             </div>


//             {/* Table */}
//             <div className="budget-lines-table-wrapper">

//                 {loading ? (

//                     <Spinner loadingInfo="Loading Budget Lines..." />

//                 ) : error ? (

//                     <p className="budget-lines-error">{error}</p>

//                 ) : budgetLines?.length === 0 ? (

//                     <p>No budget lines found.</p>

//                 ) : (

//                     <table className="budget-lines-table">

//                         <thead>

//                             <tr>
//                                 <th>Administrative Unit</th>
//                                 <th>Programme</th>
//                                 <th>Economic Segment</th>
//                                 <th>Fund</th>
//                                 <th>State</th>
//                                 <th>LGA</th>
//                                 <th>Amount</th>
//                                 <th>Spent</th>
//                                 <th>Actions</th>
//                             </tr>

//                         </thead>

//                         <tbody>

//                             {budgetLines?.map(line => (

//                                 <tr key={line._id}>

//                                     <td>{line.administrativeUnitId?.code || '-'}</td>
//                                     <td>{line.programmeId?.code || '-'}</td>
//                                     <td>{line.economicSegmentId?.code || '-'}</td>
//                                     <td>{line.fundId?.code || '-'}</td>
//                                     <td>{line.stateId?.name || '-'}</td>
//                                     <td>{line.lgaId?.name || '-'}</td>
//                                     <td>{line.amount?.toLocaleString() || '0'}</td>
//                                     <td>{line.spentAmount?.toLocaleString() || '0'}</td>

//                                     <td className="budget-lines-actions">

//                                         <Link
//                                             to="/budget-lines/detail"
//                                             state={{ budgetLine: line }}
//                                         >
//                                             <FiEye />
//                                         </Link>

//                                         {line.budgetStatus === "draft" && <Link
//                                             to="/budget-lines/edit"
//                                             state={{ budgetLine: line }}
//                                         >
//                                             <FiEdit />
//                                         </Link>}

//                                         {line.budgetStatus === "draft" && <button
//                                             onClick={() => handleDeleteClick(line._id)}
//                                             className="delete-btn"
//                                         >
//                                             <FiTrash2 />
//                                         </button>}

//                                     </td>

//                                 </tr>

//                             ))}

//                         </tbody>

//                     </table>

//                 )}

//             </div>


//             {/* Pagination */}
//             {budgetLines?.length > 0 && (

//                 <div className="budget-lines-pagination">

//                     <button
//                         onClick={prevPage}
//                         disabled={pagination.page === 1}
//                     >
//                         Prev
//                     </button>

//                     <span>
//                         Page {pagination.page} of {pagination.totalPages}
//                     </span>

//                     <button
//                         onClick={nextPage}
//                         disabled={pagination.page === pagination.totalPages}
//                     >
//                         Next
//                     </button>

//                 </div>

//             )}


//             {/* Confirm Delete */}
//             <ConfirmDialog
//                 show={confirmOpen}
//                 token={confirmToken}
//                 action="You are about to delete this budget line"
//                 onConfirm={handleConfirmDelete}
//                 onCancel={handleCancelDelete}
//             />

//         </div>
//     );
// };

// export default BudgetLines;



import React, { useEffect, useState } from 'react';
import Select from "react-select";
import './BudgetLines.css';
import privateApi from '../../apis/privateApi';
import ConfirmDialog from '../../components/ConfirmDialog/ConfirmDialog';
import { Link, useNavigate } from "react-router-dom";
import { FiEye, FiEdit, FiTrash2, FiChevronLeft, FiChevronRight } from "react-icons/fi";

const flattenSegments = (segments, level = 0) => {
    let result = [];

    segments.forEach(item => {
        result.push({
            value: item._id,
            label: "\u00A0".repeat(level * 3) + item.name,
            level,
            isLeaf: !item.hasChildren,
        });

        if (item.children?.length) {
            result = result.concat(flattenSegments(item.children, level + 1));
        }
    });

    return result;
};

const selectStyles = {
    control: (base, state) => ({
        ...base,
        borderColor: state.isFocused ? "#006B3C" : "#D2DDD5",
        boxShadow: state.isFocused ? "0 0 0 3px rgba(0,107,60,.18)" : "none",
        "&:hover": { borderColor: "#006B3C" },
        borderRadius: 6,
        minHeight: 38,
        fontSize: 13,
    }),
    menu: base => ({ ...base, zIndex: 9999 })
};

const SegSelect = ({ label, options, value, onChange, placeholder }) => (
    <div className="db-seg-group">
        <span className="db-seg-label">{label}</span>
        <Select
            styles={selectStyles}
            options={options}
            value={options.find(o => o.value === value) || null}
            onChange={opt => onChange(opt?.value || "")}
            isClearable
            isSearchable
            placeholder={placeholder}
        />
    </div>
);

const BudgetLines = () => {
    const navigate = useNavigate();

    const [budgetLines, setBudgetLines] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    const [filters, setFilters] = useState({
        minAmount: '',
        maxAmount: '',
    });

    const [location, setLocation] = useState("");

    const [administrativeUnitId, setAdministrativeUnitId] = useState("");
    const [economicSegmentId, setEconomicSegmentId] = useState("");
    const [programmeId, setProgrammeId] = useState("");
    const [fundId, setFundId] = useState("");
    const [functionalSegmentId, setFunctionalSegmentId] = useState("");

    const [administrativeUnits, setAdministrativeUnits] = useState([]);
    const [economicSegments, setEconomicSegments] = useState([]);
    const [programmes, setProgrammes] = useState([]);
    const [funds, setFunds] = useState([]);
    const [functions, setFunctions] = useState([]);

    const [pagination, setPagination] = useState({ page: 1, limit: 10, totalPages: 1, totalRecords: 0 });
    const [confirmOpen, setConfirmOpen] = useState(false);
    const [confirmToken, setConfirmToken] = useState('');
    const [deleteId, setDeleteId] = useState(null);

    const administrativeUnitOptions = flattenSegments(administrativeUnits);
    const economicSegmentOptions = flattenSegments(economicSegments);
    const programmeOptions = flattenSegments(programmes);
    const fundOptions = flattenSegments(funds);
    const functionOptions = flattenSegments(functions);

    const fetchBudgetLines = async (overridePage) => {
        try {
            setLoading(true); setError('');
            const query = new URLSearchParams({
                page: overridePage ?? pagination.page,
                limit: pagination.limit,

                scope: location || "",

                administrativeUnitId,
                economicSegmentId,
                programmeId,
                fundId,
                functionalSegmentId,

                minAmount: filters.minAmount,
                maxAmount: filters.maxAmount,
            });

            const { data } = await privateApi.get(`/api/budget-lines?${query}`);
            if (data.success) {
                setBudgetLines(data.data);
                setPagination(p => ({ ...p, totalPages: data.pagination?.pages || 1, totalRecords: data.pagination?.total || data.data?.length }));
            } else { setBudgetLines([]); setError('No records found'); }
        } catch (err) {
            setBudgetLines([]); setError(err.response?.data?.message || 'Failed to fetch budget lines.');
        } finally { setLoading(false); }
    };

    useEffect(() => {
        const initialFetchBudgetLines = async (overridePage) => {
            try {
                setLoading(true);
                setError('');

                const query = new URLSearchParams({
                    page: overridePage ?? pagination.page,
                    limit: pagination.limit,

                    scope: location || "",

                    administrativeUnitId,
                    economicSegmentId,
                    programmeId,
                    fundId,
                    functionalSegmentId,

                    minAmount: filters.minAmount,
                    maxAmount: filters.maxAmount,
                });

                const { data } = await privateApi.get(`/api/budget-lines?${query}`);

                if (data.success) {
                    setBudgetLines(data.data);
                    setPagination(p => ({
                        ...p,
                        totalPages: data.pagination?.pages || 1,
                        totalRecords: data.pagination?.total || data.data?.length
                    }));
                } else {
                    setBudgetLines([]);
                    setError('No records found');
                }
            } catch (err) {
                setBudgetLines([]);
                setError(err.response?.data?.message || 'Failed to fetch budget lines.');
            } finally {
                setLoading(false);
            }
        };

        initialFetchBudgetLines();
    }, [
        location,
        administrativeUnitId,
        economicSegmentId,
        programmeId,
        fundId,
        functionalSegmentId,
        filters.minAmount,
        filters.maxAmount,
        pagination.page,
        pagination.limit
    ]);

    useEffect(() => {
        if (!location) return;

        (async () => {
            try {
                const [
                    adminRes,
                    econRes,
                    progRes,
                    fundRes,
                    funcRes
                ] = await Promise.all([
                    privateApi.get(`/api/get-create-budget-line-administrative-units?level=${location}`),
                    privateApi.get(`/api/get-create-budget-line-economic-segments?level=${location}`),
                    privateApi.get(`/api/get-create-budget-line-programmes?level=${location}`),
                    privateApi.get(`/api/get-create-budget-line-funds?level=${location}`),
                    privateApi.get(`/api/get-create-budget-line-functional-segments?level=${location}`)
                ]);

                setAdministrativeUnits(adminRes.data.data || []);
                setEconomicSegments(econRes.data.data || []);
                setProgrammes(progRes.data.data || []);
                setFunds(fundRes.data.data || []);
                setFunctions(funcRes.data.data || []);
            } catch (err) {
                console.error(err);
            }
        })();
    }, [location]);

    // const handleChange = e => {
    //     const { name, value } = e.target;
    //     setFilters(prev => {
    //         const upd = { ...prev, [name]: value };
    //         if (name === "stateCode" && value) upd.scope = "state";
    //         if (name === "lgaCode" && value) upd.scope = "lga";
    //         return upd;
    //     });
    // };

    const handleChange = e => {
        const { name, value } = e.target;
        setFilters(prev => ({
            ...prev,
            [name]: value,
        }));
    };

    const applyFilters = () => {
        setPagination(p => ({ ...p, page: 1 }));
        fetchBudgetLines(1);
    };

    const handleDeleteClick = id => {
        const token = Math.random().toString(36).substring(2, 8).toUpperCase();
        setDeleteId(id); setConfirmToken(token); setConfirmOpen(true);
    };

    const handleConfirmDelete = async input => {
        if (input !== confirmToken) { alert('Incorrect confirmation code.'); setConfirmOpen(false); return; }
        try {
            await privateApi.delete(`/api/budget-lines/${deleteId}`);
            fetchBudgetLines();
        } catch (err) { alert(err.response?.data?.message || 'Delete failed.'); }
        finally { setConfirmOpen(false); setDeleteId(null); }
    };

    return (
        <div className="bgt-page">
            {/* Header */}
            <div className="bl-header">
                <div>
                    <h1>Budget Lines</h1>
                    <p>All budget line items across states and LGAs</p>
                </div>
                <button className="bgt-btn bgt-btn-secondary" onClick={() => navigate(-1)}>
                    <FiChevronLeft size={14} /> Back
                </button>
            </div>

            {/* Filter bar */}
            {/* <div className="bl-filter-card">
                <span className="bl-filter-tag">Filter</span>
                <select className="bl-filter-select" name="scope" value={filters.scope} onChange={handleChange}>
                    <option value="">All Scopes</option>
                    <option value="state">State</option>
                    <option value="lga">LGA</option>
                </select>
                {[
                    ["administrativeUnitCode", "Admin Unit Code"],
                    ["economicSegmentCode", "Economic Code"],
                    ["programmeCode", "Programme Code"],
                    ["fundCode", "Fund Code"],
                    ["stateCode", "State Code"],
                    ["lgaCode", "LGA Code"],
                    ["minAmount", "Min Amount"],
                    ["maxAmount", "Max Amount"],
                ].map(([name, ph]) => (
                    <input key={name} className="bl-filter-input" name={name}
                        placeholder={ph} value={filters[name]} onChange={handleChange} />
                ))}
                <button className="bgt-btn bgt-btn-primary" onClick={applyFilters}>Search</button>
                <div className="bl-filter-divider" />
                <div className="bl-filter-spacer" />
                <div className="bl-per-page-wrap">
                    <span className="bl-per-page-label">Rows</span>
                    <select className="bl-filter-select" style={{ minWidth: 70 }}
                        value={pagination.limit}
                        onChange={e => setPagination(p => ({ ...p, limit: parseInt(e.target.value, 10), page: 1 }))}>
                        <option value={10}>10</option>
                        <option value={50}>50</option>
                        <option value={100}>100</option>
                    </select>
                </div>
            </div> */}

            <div className="db-segment-bar">

                <div className="db-seg-group">
                    <span className="db-seg-label">Budget Level</span>

                    <Select
                        styles={selectStyles}
                        options={[
                            { value: "state", label: "State" },
                            { value: "lga", label: "LGA" }
                        ]}
                        value={
                            location
                                ? {
                                    value: location,
                                    label: location.toUpperCase()
                                }
                                : null
                        }
                        onChange={opt => setLocation(opt?.value || "")}
                        placeholder="Select level..."
                        isClearable
                    />
                </div>

                <SegSelect
                    label="Admin Unit"
                    options={administrativeUnitOptions}
                    value={administrativeUnitId}
                    onChange={setAdministrativeUnitId}
                    placeholder="Select unit..."
                />

                <SegSelect
                    label="Economic Segment"
                    options={economicSegmentOptions}
                    value={economicSegmentId}
                    onChange={setEconomicSegmentId}
                    placeholder="Select segment..."
                />

                <SegSelect
                    label="Functional Segment"
                    options={functionOptions}
                    value={functionalSegmentId}
                    onChange={setFunctionalSegmentId}
                    placeholder="Select function..."
                />

                <SegSelect
                    label="Fund"
                    options={fundOptions}
                    value={fundId}
                    onChange={setFundId}
                    placeholder="Select fund..."
                />

                <SegSelect
                    label="Programme"
                    options={programmeOptions}
                    value={programmeId}
                    onChange={setProgrammeId}
                    placeholder="Select programme..."
                />

                {/* Keep legacy filters still useful */}
                <input
                    className="bl-filter-input"
                    name="minAmount"
                    placeholder="Min Amount"
                    value={filters.minAmount}
                    onChange={handleChange}
                />

                <input
                    className="bl-filter-input"
                    name="maxAmount"
                    placeholder="Max Amount"
                    value={filters.maxAmount}
                    onChange={handleChange}
                />

                <button className="bgt-btn bgt-btn-primary" onClick={applyFilters}>
                    Search
                </button>

            </div>

            {/* Table */}
            <div className="bl-table-card">
                {loading ? (
                    <div className="bgt-loading-wrap"><div className="bgt-spinner" /><p className="bgt-loading-text">Loading Budget Lines…</p></div>
                ) : error ? (
                    <div className="bl-error">⚠ {error}</div>
                ) : budgetLines?.length === 0 ? (
                    <div className="bl-empty"><span className="bl-empty-icon">📋</span>No budget lines found.</div>
                ) : (
                    <div className="bl-table-scroll">
                        <table className="bl-table">
                            <thead>
                                <tr>
                                    <th>Admin Unit</th><th>Economic Seg.</th><th>Functional Seg.</th>
                                    <th>Fund</th><th>Programme</th><th>State</th><th>LGA</th>
                                    <th>Amount (₦)</th><th>Spent (₦)</th><th>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {budgetLines.map(line => (
                                    <tr key={line._id}>
                                        <td>{line.administrativeUnitId?.description || '—'}</td>
                                        <td>{line.economicSegmentId?.description || '—'}</td>
                                        <td>{line.functionalSegmentId?.description || '—'}</td>
                                        <td>{line.fundId?.description || '—'}</td>
                                        <td>{line.programmeId?.description || '—'}</td>
                                        <td>{line.stateId?.name || '—'}</td>
                                        <td>{line.lgaId?.name || '—'}</td>
                                        <td className="amount">{line.amount?.toLocaleString() || '0'}</td>
                                        <td className="spent">{line.spentAmount?.toLocaleString() || '0'}</td>
                                        <td>
                                            <div className="bl-actions">
                                                <Link className="bl-icon-btn" title="View" to="/budget-lines/detail" state={{ budgetLine: line }}><FiEye size={14} /></Link>
                                                {line.budgetStatus === "draft" && <>
                                                    <Link className="bl-icon-btn edit" title="Edit" to="/budget-lines/edit" state={{ budgetLine: line }}><FiEdit size={14} /></Link>
                                                    <button className="bl-icon-btn delete" title="Delete" onClick={() => handleDeleteClick(line._id)}><FiTrash2 size={14} /></button>
                                                </>}
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                )}
            </div>

            {/* Pagination */}
            {budgetLines?.length > 0 && (
                <div className="bl-pagination">
                    <button className="bl-page-btn" onClick={() => setPagination(p => ({ ...p, page: p.page - 1 }))} disabled={pagination.page === 1}>
                        <FiChevronLeft size={13} /> Prev
                    </button>
                    <span className="bl-page-info">Page {pagination.page} of {pagination.totalPages} <span style={{ opacity: .6 }}>({pagination.totalRecords} total)</span></span>
                    <button className="bl-page-btn" onClick={() => setPagination(p => ({ ...p, page: p.page + 1 }))} disabled={pagination.page === pagination.totalPages}>
                        Next <FiChevronRight size={13} />
                    </button>
                </div>
            )}

            <ConfirmDialog show={confirmOpen} token={confirmToken}
                action="You are about to delete this budget line"
                onConfirm={handleConfirmDelete}
                onCancel={() => { setConfirmOpen(false); setDeleteId(null); }} />
        </div>
    );
};

export default BudgetLines;